const OTP_SESSION_KEY = "otpSession";

export function mapOtpProfileFromResponse(response = {}) {
  return {
    firstname: response.firstname || "",
    lastname: response.lastname || "",
    email: response.email || "",
    phone: response.phone || "",
    bookingname: response.bookingname || "",
    notes: response.notes || "",
    address: response.address || "",
    businessname: response.businessname || "",
    tradingas: response.tradingas || "",
    abn: response.abn || "",
  };
}

export function mapOtpContactFromProfile(profile = {}) {
  return {
    FirstName: profile.firstname || "",
    LastName: profile.lastname || "",
    Email: profile.email || "",
    Phone: profile.phone || "",
    BookingName: profile.bookingname || "",
    Notes: profile.notes || "",
    Address: profile.address || "",
    companyName: profile.businessname || "",
    TradeAs: profile.tradingas || "",
    ABN: profile.abn || "",
    businessBooking: Boolean(profile.businessname?.trim()),
  };
}

export function getOtpSession() {
  try {
    const raw = sessionStorage.getItem(OTP_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveOtpSession(session) {
  if (!session) {
    return;
  }
  sessionStorage.setItem(OTP_SESSION_KEY, JSON.stringify(session));
}

export function clearOtpSession() {
  sessionStorage.removeItem(OTP_SESSION_KEY);
  sessionStorage.removeItem("onetimeToken");
  sessionStorage.removeItem("readOnlyOTP");
  sessionStorage.removeItem("otpUserBookingHours");
  sessionStorage.removeItem("otpUserId");
  sessionStorage.removeItem("email");
  sessionStorage.removeItem("isOtpBooking");
}

export function isOtpUser() {
  return (
    sessionStorage.getItem("readOnlyOTP") === "true" ||
    Boolean(getOtpSession()?.token)
  );
}

export function isOtpBookingCheckout() {
  return sessionStorage.getItem("isOtpBooking") === "true";
}

export function markOtpBookingCheckout() {
  sessionStorage.setItem("isOtpBooking", "true");
}

export function getOtpBookingHoursRemaining() {
  const session = getOtpSession();
  if (session?.bookingHoursRemaining != null) {
    return Number(session.bookingHoursRemaining);
  }

  const stored = sessionStorage.getItem("otpUserBookingHours");
  if (stored === null || stored === "") {
    return null;
  }

  const hours = Number(stored);
  return Number.isNaN(hours) ? null : hours;
}

export function setOtpBookingHoursRemaining(hours) {
  const normalized = Number(hours);
  const value = Number.isNaN(normalized) ? 0 : normalized;
  sessionStorage.setItem("otpUserBookingHours", String(value));

  const session = getOtpSession();
  if (session) {
    saveOtpSession({
      ...session,
      bookingHoursRemaining: value,
    });
  }
}

export function deductOtpBookingHours(hoursUsed) {
  const current = getOtpBookingHoursRemaining();
  if (current == null) {
    return null;
  }
  const next = Math.max(0, current - Number(hoursUsed || 0));
  setOtpBookingHoursRemaining(next);
  return next;
}

export function persistOtpSessionFromLookupAndLogin({
  facility,
  venueType,
  lookupResponse,
  loginResponse,
}) {
  const profile = mapOtpProfileFromResponse(lookupResponse || {});
  const bookingHoursRemaining = Number(
    loginResponse?.bookinghours ?? lookupResponse?.bookinghours ?? 0
  );

  const session = {
    facility: facility || loginResponse?.facility || "",
    otpUserId: lookupResponse?.id || "",
    email: loginResponse?.email || profile.email || "",
    venueType: venueType || loginResponse?.venuetype || "",
    token: loginResponse?.token || "",
    bookingHoursRemaining: Number.isNaN(bookingHoursRemaining)
      ? 0
      : bookingHoursRemaining,
    profile,
  };

  saveOtpSession(session);
  sessionStorage.setItem("onetimeToken", session.token);
  sessionStorage.setItem("email", session.email);
  sessionStorage.setItem("readOnlyOTP", "true");
  sessionStorage.setItem("otpUserId", session.otpUserId || "");
  setOtpBookingHoursRemaining(session.bookingHoursRemaining);

  return session;
}

export function syncLegacyOtpSessionFromStorage() {
  const token = sessionStorage.getItem("onetimeToken");
  if (!token) {
    return null;
  }

  const existing = getOtpSession();
  if (existing?.token) {
    return existing;
  }

  const hours = getOtpBookingHoursRemaining();
  const session = {
    facility: "",
    otpUserId: sessionStorage.getItem("otpUserId") || "",
    email: sessionStorage.getItem("email") || "",
    venueType: sessionStorage.getItem("selectedvenuetype") || "",
    token,
    bookingHoursRemaining: hours == null ? 0 : hours,
    profile: {
      email: sessionStorage.getItem("email") || "",
    },
  };

  saveOtpSession(session);
  return session;
}

export function getOtpPaymentTxnDetail() {
  return {
    amount: 0,
    amountOriginal: 0,
    responseCode: "0",
    responseText: "OTP complimentary booking",
  };
}

function parseBookingDateTime(value) {
  if (!value || typeof value !== "string") {
    return null;
  }

  const match = value.trim().match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})/
  );
  if (!match) {
    return null;
  }

  return new Date(
    Number(match[3]),
    Number(match[2]) - 1,
    Number(match[1]),
    Number(match[4]),
    Number(match[5]),
    0,
    0
  );
}

export function slotDurationHours(startTime, endTime) {
  const start = parseBookingDateTime(startTime);
  const end = parseBookingDateTime(endTime);
  if (!start || !end || end <= start) {
    return 0;
  }
  return (end.getTime() - start.getTime()) / 3_600_000;
}

export function getWizardSessionDurationHours(booking) {
  if (!booking) {
    return 0;
  }
  return slotDurationHours(
    booking.displayStartTime || booking.StartTime,
    booking.displayEndTime || booking.EndTime
  );
}
